import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=f1a68740&scoped=true&"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordView.vue?vue&type=style&index=0&id=f1a68740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a68740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1a68740')) {
      api.createRecord('f1a68740', component.options)
    } else {
      api.reload('f1a68740', component.options)
    }
    module.hot.accept("./ForgotPasswordView.vue?vue&type=template&id=f1a68740&scoped=true&", function () {
      api.rerender('f1a68740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ForgotPasswordView.vue"
export default component.exports